import { createTheme } from '@mui/material/styles';

const DARK_BLUE = '#0094ca';

export default createTheme({
  palette: {
    primary: {
      main: DARK_BLUE,
    },
  },
  typography: {
    h1: {
      fontFamily: ['Raleway', '"Open Sans"', 'sans-serif'].join(','),
      fontSize: '3em',
      fontWeight: '300',
    },
    subtitle1: {
      fontSize: '1rem',
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      fontWeight: 400,
      lineHeight: 1.5,
      letterSpacing: '0.00938em',
      color: 'rgba(0, 0, 0, 0.54)',
    },
  },
  overrides: {
    MuiTooltip: {
      tooltip: {
        fontSize: '0.85em',
      },
    },
    MuiToggleButton: {
      // Override the styling for selected toggle buttons
      root: {
        '&$selected': {
          backgroundColor: DARK_BLUE,
          color: 'white',
        },
      },
    },
  },
});
